import React from 'react';
import { useAuth } from 'app/javascript/contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { currentUser, loading } = useAuth();

  if (loading) return null;

  // Keep the URL private: never reveal the login route to anonymous visitors.
  if (!currentUser?.appAdmin) {
    return <main className="p-8 text-slate-300"><h1>404 — Página não encontrada</h1></main>;
  }

  return <>{children}</>;
}
